import { ReactNode } from 'react';

import { useJsApiLoader } from '@react-google-maps/api';

/** More info: https://react-google-maps-api-docs.netlify.app/ */

interface GoogleMapsScriptProps {
    googleMapsApiKey: string;
    children?: ReactNode | undefined;
}

type GoogleMapsLibrary = 'drawing' | 'geometry' | 'localContext' | 'places' | 'visualization';

const libraries = ['places'] as GoogleMapsLibrary[];

const GoogleMapsScriptProvider = ({
    googleMapsApiKey,
    children,
}: GoogleMapsScriptProps): JSX.Element => {
    const { isLoaded } = useJsApiLoader({
        id: 'google-map-script',
        googleMapsApiKey: googleMapsApiKey,
        libraries: libraries,
    });
    return isLoaded && <>{children}</>;
};

export default GoogleMapsScriptProvider;
